import { defineComponent as _defineComponent } from 'vue';
import { useAttrs } from 'vue';
import { ComboboxInput } from 'reka-ui';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'ComboboxInput',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        displayValue: { type: Function, required: false },
        disabled: { type: Boolean, required: false },
        readonly: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const attrs = useAttrs();
        const __returned__ = { props, attrs, get ComboboxInput() { return ComboboxInput; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
